module.exports = __webpack_public_path__ + "img/background006.724e2e3a.jpg";